module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "banner"
  }, [(_vm.$store.state.isOnSite) ? _c('OnSiteFooter', {
    staticStyle: {
      "z-index": "1000000"
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-661b5616"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/SkiRental/SkiRentalOnSitePage.vue
// module id = 987
// module chunks = 0